import './style.css';

const ContentWrap: React.FC<{
    children?: React.ReactNode;
}> = ({ children }) => {
    return <div className='content-wrap'>{children}</div>;
};

export default ContentWrap;
